import { render } from "./lockedHotspot.vue?vue&type=template&id=8e0ccf26"
import script from "./lockedHotspot.vue?vue&type=script&lang=js"
export * from "./lockedHotspot.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__